module.exports = __webpack_public_path__ + "img/lg_ring_g_s_0_null.e89604ee.png";